import React from 'react';

const DashCard = ({ counterCard = false, className = '', children, ...rest }) => {
    const classes = ['dash-card', counterCard && 'counter-card', className]
        .filter(Boolean)
        .join(' ');

    return (
        <section className={classes} {...rest}>
            {children}
        </section>
    );
};

export default DashCard;
